import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const languages = {
  sk: 'SK',
  en: 'EN',
  de: 'DE'
};

// Detect user's preferred language from browser
const detectLanguage = () => {
  // Check if user has previously selected a language
  const savedLanguage = localStorage.getItem('workpro-language');
  if (savedLanguage && ['sk', 'en', 'de'].includes(savedLanguage)) {
    return savedLanguage;
  }

  // Get browser language
  const browserLang = navigator.language || navigator.userLanguage;
  const langCode = browserLang.split('-')[0].toLowerCase();

  // Map browser language to supported languages
  if (langCode === 'sk' || langCode === 'cs') {
    // Slovak or Czech -> Slovak
    return 'sk';
  } else if (langCode === 'de' || langCode === 'at') {
    // German or Austrian -> German
    return 'de';
  } else {
    // Everything else (including English) -> English
    return 'en';
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(detectLanguage);

  // Save language preference when changed
  useEffect(() => {
    localStorage.setItem('workpro-language', language);
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage, languages }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
